import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const TRANSLATION_KEY = 'PowerSupplySettings.string';

export function Heading(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const TEXT = t(TRANSLATION_KEY);

  return <h4 className={props.className}>{TEXT}</h4>;
}

Heading.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};
Heading.defaultProps = {
  className: '',
};
